import { Flex, Heading, Button, Input, Box, FormControl, FormLabel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Select, FormErrorMessage, FormHelperText, Stack, Checkbox, Spinner } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb'
import CustomInput from '../../../../components/common/Input/input'
import { useIMask } from 'react-imask';
import * as api from '../../../../api/usuario';
import { auth } from '../../../../api/auth'
import Swal from 'sweetalert2'
import { listarCategoriasAtivas } from '../../../../api/categoria'
import './adicionar-usuario.scss'
import { Camera } from "lucide-react";
import { listarSecretariasAtivas } from '../../../../api/secretarias'

function AdicionarUsuario() {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [codPerfilAcesso, setTipoPerfil] = useState<any[]>([]);
  const [campoObrigatorio, setCampoObrigatorio] = useState<boolean>(false);
  const [isCpfValido, setIsCpfValido] = useState<boolean>(false);
  const [isEmailValido, setEmailValido] = useState<boolean>(false);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState<number[]>([]);
  const [secretarias, setSecretarias] = useState<any[]>([]);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState<number[]>([]);
  const [image, setImage] = useState<any>();
  const [profileImage, setProfileImage] = useState<File | null>(null);
  const [profileImagePreview, setProfileImagePreview] = useState<string>("");
  const [imageBase64, setImageBase64] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    const fetchTipoPerfis = async () => {
      try {
        const data = await api.listarTiposPerfisAtivos();
        setTipoPerfil(data);
      } catch (error) {
        console.error('Erro ao buscar tipos de perfis ativos:', error);
      }
    };

    fetchTipoPerfis();
    fetchcategorias();
    fetchSecretariasAtivas();
  }, []);

  const fetchcategorias = async () => {
    try {
      const data = await listarCategoriasAtivas();
      setCategorias(data);
    } catch (error) {
      console.error('Erro ao buscar categorias ativas:', error);
    }
  };

  const fetchSecretariasAtivas = async () => {
    try {
      const data = await listarSecretariasAtivas();
      setSecretarias(data);
    } catch (error) {
      console.error('Erro ao buscar secretarias ativas:', error);
    }
  };
  
  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setProfileImage(file);
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === "string") {
          setProfileImagePreview(reader.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCheckboxChange = (seqCategoria: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setCategoriaSelecionada((prev) => {
      const updatedPages = isChecked ? [...prev, seqCategoria] : prev.filter((id) => id !== seqCategoria);
      return updatedPages;
    });

    setFormValues((prevValues: any) => {
      const updatedcategoriaIdValue = isChecked
        ? [...prevValues.categoriaId.value, seqCategoria]
        : prevValues.categoriaId.value.filter((id: number) => id !== seqCategoria);

      return {
        ...prevValues,
        categoriaId: { value: updatedcategoriaIdValue },
        ordemBanner: { value: 0 },
      };
    });
  };

  const handleCheckboxSecretaria = (codSecretaria: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;

    setSecretariaSelecionada((prev) => {
      const updatedPages = isChecked ? [...prev, codSecretaria] : prev.filter((id) => id !== codSecretaria);
      return updatedPages;
    });

    setFormValues((prevValues: any) => {
      const updatedSecretariaIdValue = isChecked
        ? [...prevValues.secretariaId.value, codSecretaria]
        : prevValues.secretariaId.value.filter((id: number) => id !== codSecretaria);

      return {
        ...prevValues,
        secretariaId: { value: updatedSecretariaIdValue },
        ordemBanner: { value: 0 },
      };
    });
  };

  const [formValues, setFormValues] = useState({
    dscCpf: {
      value: '',
      error: false
    },
    dscNome: {
      value: '',
      error: false
    },
    dscDdd: {
      value: '',
      error: false
    },
    dscCelular: {
      value: '',
      error: false
    },
    dscEmail: {
      value: '',
      error: false
    },
    dscSenha: {
      value: '',
      error: false
    },
    codPerfilAcesso: {
      value: '',
      error: false
    },
    categoriaId: {
      value: [],
      error: false
    },
    secretariaId: {
      value: [],
      error: false
    },
  })

  const { ref: cpfRef } = useIMask(
    { mask: '000.000.000-00' },
    {
      onAccept: (value) => handleFieldChange('dscCpf', value)
    }
  );

  const { ref: celularRef } = useIMask(
    { mask: '00000-0000' },
    {
      onAccept: (value) => handleFieldChange('dscCelular', value)
    }
  );

  /* eslint-disable-next-line */
  const senhaRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[#\$%!@]).{8,255}$/;

  const validarSenha = (senha: string) => {
    return senhaRegex.test(senha);
  };

  /* eslint-disable-next-line */
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;

  const autenticarCpf = async (cpf: string) => {
    try {
      const data = await api.autenticarCpf(cpf);
      setIsCpfValido(true);

      Swal.fire({
        icon: 'warning',
        title: 'CPF já cadastrado!',
        html: 'Este CPF já está cadastrado na plataforma. </br> Deseja ir para a página de edição deste usuário?',
        showCancelButton: true,
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'Editar usuário',
        cancelButtonText: 'Desistir',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(`/cms/configuracao/gerenciar-usuario/editar-usuario/${data.seqUsuario}`);
        }
        else if (result.dismiss === Swal.DismissReason.cancel) {
          navigate('/cms/configuracao/gerenciar-usuario');
        }
      });
    } catch (error) {
      setIsCpfValido(false);
      console.error('cpf não encontrado:', error);
    }
  };

  const isFormValid = () => {
    const { dscCpf, dscNome, dscDdd, dscCelular, dscEmail, dscSenha, codPerfilAcesso, categoriaId } = formValues;
    const isCelularObrigatorio = campoObrigatorio == true ? (dscDdd.value.length >= 2 && dscCelular.value.length >= 9) : true;
    const isEmailValido = emailRegex.test(dscEmail.value);

    return (
      dscCpf.value && dscNome.value && dscEmail.value &&
      // dscSenha.value &&
      dscCpf.value.length >= 12 &&
      (dscNome.value.length >= 3 && dscNome.value.length <= 160) &&
      dscEmail.value.length <= 80 &&
      isEmailValido &&
      // dscSenha.value.length >= 8 &&
      // dscSenha.value.length <= 255 &&
      // validarSenha(dscSenha.value) &&
      (codPerfilAcesso.value != null) &&
      (categoriaId.value.length > 0) &&
      isCelularObrigatorio
    );
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormValues({
      ...formValues,
      [field]: {
        error: false,
        value
      }
    });

    if (field === 'dscEmail') {
      const isEmailValido = emailRegex.test(value);
      setEmailValido(isEmailValido);
    }

    // if (field === 'dscSenha') {
    //   const isSenhaValida = validarSenha(value);
    //   setFormValues(prevState => ({
    //     ...prevState,
    //     dscSenha: {
    //       value,
    //       error: !isSenhaValida
    //     }
    //   }));
    // }
  };


  const handleSubmit = async () => {
    try {
      const tokenAcesso = localStorage.getItem("token");
      const lastTokenDate = localStorage.getItem("tokenDate");
      const isTokenValid =
        tokenAcesso &&
        lastTokenDate &&
        new Date(lastTokenDate).toDateString() === new Date().toDateString();
  
      if (!isTokenValid) {
        const res = await auth("password", 0, "AdmCMS", "CMS@951");
        const newTokenAcesso = res.data.access_token;
        localStorage.setItem("token", newTokenAcesso);
        localStorage.setItem("tokenDate", new Date().toISOString());
      }
  
      const token = localStorage.getItem("token");
      if (!token) {
        setErrorMessage("Token de acesso não encontrado.");
        return;
      }
  
      const {
        dscCpf,
        dscNome,
        dscDdd,
        dscCelular,
        dscEmail,
        dscSenha,
        codPerfilAcesso,
        categoriaId,
        secretariaId
      } = formValues;
  
      const params = {
        dscCpf: dscCpf.value.replace(/\.|-/gm, "") || null,
        dscNome: dscNome.value || null,
        dscDdd: dscDdd.value || null,
        dscCelular: dscCelular.value.replace(/\.|-/gm, "") || null,
        dscEmail: dscEmail.value || null,
        dscSenha: "Senha@01" || null,
        codPerfilAcesso: Number(codPerfilAcesso.value),
        token: `bearer ${token}`,
        usuarioCategoriaDTO: categoriaId.value.map((id: number) => ({
          seqCategoria: id,
        })),
        imagemUsuario: profileImage ? { imagem: "" } : null,
        usuarioSecretariaDTO: secretariaId.value.map((id: number) => ({
          codSecretaria: id,
        })),
      };
  
      if (profileImage) {
        const formDataProfile = new FormData();
        formDataProfile.append("file", profileImage);
  
        const fileExtension = profileImage.name.split(".").pop();
        let fileNameToSend = "imagemUsuario";
        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }
        formDataProfile.append("fileName", fileNameToSend);
        formDataProfile.append("folderName", "imgUsuario");
  
        const cdnProfileData = await api.inserirFotoPerfilNoCdn(formDataProfile);
        let profileCdnUrl = "";
        if (typeof cdnProfileData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnProfileData.match(regex);
          if (match && match[0]) {
            profileCdnUrl = match[0];
          } else {
            throw new Error(
              "URL não encontrada na resposta do CDN para foto de perfil."
            );
          }
        } else if (cdnProfileData && cdnProfileData.url) {
          profileCdnUrl = cdnProfileData.url;
        } else {
          throw new Error("Resposta do CDN para foto de perfil inesperada.");
        }
  
        params.imagemUsuario = { imagem: profileCdnUrl };
      }
  
      setIsLoading(true);
      await api.inserirUsuario(params);
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        html: "Usuário adicionado com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/configuracao/gerenciar-usuario");
      });
    } catch (error) {
      setErrorMessage("Houve um problema ao adicionar o usuário. Tente novamente.");
      Swal.fire({
        icon: "error",
        title: "Ocorreu um erro",
        html: "Não conseguimos adicionar o usuário no momento. Por favor, tente novamente mais tarde.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/configuracao/gerenciar-usuario");
      });
      setIsLoading(false);
    }
  };  
  
  const validarObrigatoriedadeTelefone = async () => {
    const { dscDdd, dscCelular } = formValues;
    dscDdd.value.length >= 1 || dscCelular.value.length >= 1 ? setCampoObrigatorio(true) : setCampoObrigatorio(false);
  }

  useEffect(() => {
    validarObrigatoriedadeTelefone();
  });

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Adicionar Usuário
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <><div className="row mb-3">
          <div className="col-md-6 mb-4">
            <FormControl isRequired isInvalid={formValues.codPerfilAcesso.error}>
              <FormLabel mb="8px">Perfil de Usuário</FormLabel>
              <Select
                placeholder='Selecione o tipo de perfil'
                borderColor="gray.300"
                _hover={{ borderColor: 'blue.500' }}
                value={formValues.codPerfilAcesso.value}
                onChange={(e) => handleFieldChange('codPerfilAcesso', e.target.value)}
              >
                {codPerfilAcesso.length != null ? (
                  codPerfilAcesso.map(perfil => (
                    <option key={perfil.codPerfilAcesso} value={perfil.codPerfilAcesso}>
                      {perfil.dscPerfilAcesso}
                    </option>
                  ))
                ) : (
                  <option disabled>Sem tipos de perfis disponíveis</option>
                )}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">CPF</FormLabel>
              <Input
                placeholder='Digite um CPF'
                backgroundColor={'#fff'}
                variant="outline"
                borderColor="gray.300"
                _hover={{
                  borderColor: 'blue.500',
                }}
                _focus={{
                  borderColor: 'blue.500',
                  boxShadow: '0 0 0 1px blue.500',
                }}
                ref={cpfRef}
                value={formValues.dscCpf.value}
                onBlur={() => autenticarCpf(formValues.dscCpf.value.replace(/\.|-/gm, ''))}
                onChange={(e) => handleFieldChange('dscCpf', e.target.value.trim())}
                minLength={11}
                maxLength={60} />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Nome</FormLabel>
              <CustomInput
                placeholder='Digite um nome'
                value={formValues.dscNome.value}
                onChange={(e) => handleFieldChange('dscNome', e.target.value)}
                maxLength={160}
                minLength={3} />
            </FormControl>
          </div>
          <div className="col-md-2 mb-4">
            <FormControl isRequired={campoObrigatorio}>
              <FormLabel mb="8px">DDD do celular</FormLabel>
              <CustomInput
                placeholder='DDD'
                value={formValues.dscDdd.value}
                onChange={(e) => handleFieldChange('dscDdd', e.target.value)}
                minLength={2}
                maxLength={2} />
            </FormControl>
          </div>
          <div className="col-md-4 mb-4">
            <FormControl isRequired={campoObrigatorio}>
              <FormLabel mb="8px">Número do Celular</FormLabel>
              <CustomInput
                placeholder='Digite um número de celular'
                ref={celularRef}
                value={formValues.dscCelular.value.trim()}
                onChange={(e) => handleFieldChange('dscCelular', e.target.value.trim())}
                minLength={10}
                maxLength={10} />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired isInvalid={!isEmailValido} marginBottom={'24px'}>
              <FormLabel mb="8px">E-mail</FormLabel>
              <CustomInput
                placeholder='Digite um e-mail'
                type={'email'}
                value={formValues.dscEmail.value}
                onChange={(e) => handleFieldChange('dscEmail', e.target.value)}
                maxLength={80} />
              {!isEmailValido && (
                <FormErrorMessage>Por favor, insira um e-mail válido.</FormErrorMessage>
              )}
            </FormControl>
            <FormControl className="mb-4 profile-upload">
              <label className="upload-label">
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={handleImageChange} 
                />
                <div className="image-preview">
                  {profileImagePreview ? (
                    <img src={profileImagePreview} alt="Profile" />
                  ) : (
                    <span>Foto de Perfil</span>
                  )}
                </div>
                <div className="camera-icon">
                  <Camera size={20} />
                </div>
              </label>
            </FormControl>
            <FormControl className='mb-4'>
              {secretarias.length > 0 && (
                <>
                  <Flex justify="space-between" align="center" mb="8px">
                    <FormLabel mb="8px">
                      Associe o usuário a uma secretaria (opcional)
                    </FormLabel>
                  </Flex>

                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    p={3}
                  >
                    <Box overflow="hidden">
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'center', padding:'8px', borderBottom:'1px solid #ddd' }}></th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Código</th>
                            <th style={{ textAlign:'left',   padding:'8px', borderBottom:'1px solid #ddd', color:'gray' }}>Secretaria</th>
                          </tr>
                        </thead>
                      </table>
                    </Box>

                    <Box 
                      className="sidebar-checkbox-pagina"
                      overflowX="auto"
                      overflowY={secretarias.length > 5 ? 'auto' : 'visible'}
                      maxH={secretarias.length > 5 ? '240px' : 'unset'}
                    >
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <colgroup>
                          <col style={{ width: '60px' }} />
                          <col style={{ width: '120px' }} />
                          <col />
                        </colgroup>
                        <tbody>
                        {secretarias.map((secretaria: any) => (
                          <tr key={secretaria.codSecretaria}>
                            <td style={{ textAlign: "center", padding: "8px", borderBottom: "1px solid #ddd" }}>
                              <Checkbox
                                className="checkCategorias"
                                isChecked={secretariaSelecionada.includes(secretaria.codSecretaria)}
                                onChange={(e) => handleCheckboxSecretaria(secretaria.codSecretaria, e)}
                              />
                            </td>
                            <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                              {secretaria.codSecretaria}
                            </td>
                            <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
                              {secretaria.dscSecretaria}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      </table>
                    </Box>
                  </Box>
                </>
              )}
            </FormControl>
          </div>
          {/* <div className="col-md-6 mb-4">
            <FormControl isRequired isInvalid={formValues.dscSenha.error && formValues.dscSenha.value.length >= 1}>
              <FormLabel mb="8px">Senha</FormLabel>
              <CustomInput
                placeholder='Digite uma senha'
                type={'password'}
                value={formValues.dscSenha.value}
                onChange={(e) => handleFieldChange('dscSenha', e.target.value)}
                minLength={8}
                maxLength={255} />
              {formValues.dscSenha.error && formValues.dscSenha.value.length >= 1 && (
                <FormErrorMessage>
                  A senha deve possuir no mínimo 8 caracteres, e deve conter letras, números e pelo menos um dos seguintes sinais: #$%!@.
                </FormErrorMessage>
              )}
            </FormControl>
          </div> */}
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <Flex justify="space-between" align="center" mb="8px">
                <FormLabel mb="8px">
                  Escolha as categorias de publicações permitidas para este usuário
                </FormLabel>
              </Flex>
              <div className="sidebar-checkbox-pagina">
                <Stack spacing={5}>
                  {categorias.length > 0 ? (
                    categorias.map((pagina: any) => (
                      <Flex key={pagina.seqCategoria} align="center" justify="space-between" direction={{ base: 'column', md: 'row' }}>
                        <Checkbox
                          className="checkCategorias"
                          isChecked={categoriaSelecionada.includes(pagina.seqCategoria)}
                          onChange={(e) => handleCheckboxChange(pagina.seqCategoria, e)}
                        >
                          {pagina.dscCategoria}
                        </Checkbox>
                      </Flex>
                    ))
                  ) : (
                    <p>Não há categorias disponíveis.</p>
                  )}
                </Stack>
              </div>
            </FormControl>
          </div>
        </div>
          <Flex justifyContent="end">
            <Button type="submit" m="6px" onClick={() => navigate(-1)}>
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              onClick={() => {
                handleSubmit()
                // navigate(-1);
              }}
              isDisabled={!isFormValid()}
            >
              Adicionar Usuário
            </Button>
          </Flex></>)}

      <Modal isOpen={isSuccessModalOpen} onClose={() => {
        setIsSuccessModalOpen(false);
        navigate('/cms/configuracao/gerenciar-usuario');
      }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Sucesso!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>Usuário adicionado com sucesso!</ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={() => {
              setIsSuccessModalOpen(false);
              navigate('/cms/configuracao/gerenciar-usuario');
            }}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isErrorModalOpen} onClose={() => setIsErrorModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Atenção!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{errorMessage}</ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={() => setIsErrorModalOpen(false)}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  )
}

export default AdicionarUsuario;
